// extracted by mini-css-extract-plugin
export default {"container":"AccountLayout_container__blyEY","flexGrid":"AccountLayout_flexGrid__IyFk1"};